import { render, staticRenderFns } from "./IconColumn.vue?vue&type=template&id=2a4a6ba0&scoped=true&"
import script from "./IconColumn.vue?vue&type=script&lang=js&"
export * from "./IconColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a6ba0",
  null
  
)

export default component.exports